import * as React from "react"
import Layout from "../components/layout/layout";
import Info from "../data/data"
import Seo from "../data/seo"
import PodologyProblems from "../components/pages/index/podology-problems";
import Opinions from "../components/pages/index/opinions";
import welcomeImg from "../images/podolog-kielce.jpg"
import WhyManufacture from "../components/pages/index/why-manufacture";
import Services from "../components/pages/index/services";
import OfficeInfo from "../components/pages/index/office-info";
import Equipment from "../components/pages/index/equipment";
import {Link} from "gatsby";

const IndexPage = () => {
    return (
        <Layout seo={Seo.index}>

            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="py-5">
                            <h1 className="display-5 fw-bold" data-sal="slide-right" data-sal-easing="ease-in-quad" data-sal-delay="100">
                                Podolog Kielce
                            </h1>
                            <p data-sal="slide-right" data-sal-easing="ease-in-quad" data-sal-delay="150">
                                <p className="fs-4">
                                    Szukasz specjalisty, który kompleksowo i skutecznie zajmie się zdrowiem Twoich stóp?
                                </p>
                                <p className="fs-4">
                                    Zobacz co możemy dla Ciebie zrobić i odwiedź nasz profesjonalny gabinet podologiczny.
                                </p>
                            </p>
                        </div>
                        <div className="pb-5">
                            <h2 className="fw-bold" data-sal="slide-right" data-sal-easing="ease-in-quad" data-sal-delay="120">
                                Co nas wyróżnia?
                            </h2>
                            <p data-sal="slide-right" data-sal-easing="ease-in-quad" data-sal-delay="140">
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Wykształcenie medyczne
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Budynek dostosowany dla osób niepełnosprawnych
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Wykonujemy pedicure <Link to="/podologia/kart">KART</Link>
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Kącik dla dzieci
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Darmowy parking
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Gabinet w cichym i spokojnym miejscu
                                </p>
                                <p className="fs-4">
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Szybki dojazd z centrum Kielc
                                </p>
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img className="img-fluid py-4" src={welcomeImg} alt={Info.expert}
                             data-sal="slide-left" data-sal-delay="300" data-sal-duration="400"/>
                    </div>
                </div>
            </div>

            <Services/>

            <div className="container py-4">

                <PodologyProblems/>

                <Opinions/>

                <Equipment/>

                <WhyManufacture/>

                <OfficeInfo/>

            </div>
        </Layout>
    )
}

export default IndexPage